<template>
  <div>
    <van-nav-bar title="考勤" />
    <div class="wrap">
      <div class="list">
        <!-- <div class="item" @click="clickItem('outwork')">
          <div class="icon">
            <img
              src="data:image/jpeg;base64,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"
              alt=""
            />
          </div>
          <div class="text">外勤</div>
        </div> -->
        <div
          class="item"
          @click="clickItem('myattendance')"
          v-if="personType != 12"
        >
          <div class="icon">
            <img src="@/assets/images/kaoqin.png" alt="" />
          </div>
          <div class="text">考勤</div>
        </div>
        <div class="item" @click="clickItem('leaveList')">
          <div class="icon">
            <img src="@/assets/images/qingjia.png" alt="" />
          </div>
          <div class="text">请假</div>
        </div>
        <div class="item" @click="clickItem('attendanceStatistics')">
          <div class="icon">
            <img src="@/assets/images/tongji.png" alt="" />
          </div>
          <div class="text">统计</div>
        </div>
        <div
          class="item"
          @click="clickItem('pickupList')"
          v-if="personType == 12"
        >
          <div class="icon">
            <img src="@/assets/images/dai.png" alt="" />
          </div>
          <div class="text">代接送</div>
        </div>
        <!-- <div
          class="item"
          @click="clickItem('accessList')"
          v-if="personType == 12"
        >
          <div class="icon">
            <img src="@/assets/images/jinchu.png" alt="" />
          </div>
          <div class="text">进出授权</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    personType() {
      return JSON.parse(localStorage.getItem('userInfo')).personType
    },
  },
  methods: {
    clickItem(type) {
      this.$router.push('/' + type)
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  margin: 1rem;
  box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.03);
}

.list {
  display: flex;
  border-radius: 0.75rem;
  overflow: hidden;
  background: #fff;

  .item {
    /* width: 7.8125rem; */
    padding: 0 1rem;
    margin: 1rem 0;
    flex: 1;
    border-right: 1px solid #f4f4f6;

    &:nth-child(4n) {
      border-right: none;
    }

    .icon {
      /* padding: 1rem 0; */
      img {
        width: 2rem;
        height: 2rem;
        display: block;
        margin: 0 auto;
      }
    }

    .text {
      text-align: center;
      /* padding: 0.3rem 0; */
      margin-top: 0.5rem;
      font-size: 0.75rem;
      /* border-top: 1px solid #f4f4f6; */
    }
  }
}
</style>
